<template>
  <footer class="px-5 lg:px-10 py-6 lg:py-8 bg-brown text-egg">
    <div class="h-10 flex items-center text-2-mob xl:text-3-desk font-title">
      <RouterLink :to="{ name: 'About' }">ABOUT</RouterLink>
      <RouterLink
        :to="{ name: 'Stories' }"
        class="hidden xl:block ml-10 xl:ml-16"
        >STORIES</RouterLink
      >
      <RouterLink :to="{ name: 'Terms' }" class="ml-10 xl:ml-16"
        >COOKIES</RouterLink
      >
      <BlockEmail class="ml-auto xl:ml-16 font-body" />
      <span v-if="globals" class="ml-16 opacity-30 uppercase hidden xl:block">{{
        globals.mailingList.heading
      }}</span>
      <BlockSignUp class="ml-16 font-body hidden xl:block" />
    </div>
  </footer>
</template>

<script>
import { globals } from "@io/global";
import BlockSignUp from "./BlockSignUp";
import BlockEmail from "./BlockEmail";

export default {
  name: "BlockFooter",

  components: {
    BlockSignUp,
    BlockEmail
  },

  computed: {
    globals
  }
};
</script>
